<template>
    <div class="content-card" :class="bemFacets">
        <div class="content-card--wrapper">
            <div class="content-card--header-image">
                <slot name="image"/>
            </div>

            <div class="content-card--content-wrapper">
                <div class="content-card--title">
                    <slot name="title"/>
                </div>

                <div class="content-card--content">
                    <slot name="content"/>
                </div>
            </div>

            <div class="content-card--links">
                <slot name="links"/>
            </div>
        </div>
    </div>
</template>

<script>

    import bemMixin from 'framework/mixins/bem';


    export default {
        mixins: [bemMixin('content-card')],

        props: {},
    };
</script>
